import { styled } from '@mui/material'
import { memo } from 'react'
import Iconfont from '../Iconfont'

const Modal = styled('div')`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .iconfont {
    color: #8ecd1e;
  }
  h1 {
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    color: #070707;
    margin: 16px auto 12px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #474d65;
    max-width: 500px;
    margin: 0 auto;
    strong {
      color: #0059e3;
    }
  }
`

export const MaintenanceModel = memo(() => {
  return (
    <Modal>
      <Iconfont name="icon-a-nodata" size={98} />
      <h1>ZKEX is temporarily down for maintenance</h1>
      <p> Sorry for the inconvenience.We will be back soon.</p>
      <p>
        {' '}
        Please follow our{' '}
        <a href="https://twitter.com/ZKEX_Official">
          <strong>Twitter</strong>
        </a>{' '}
        and join our{' '}
        <a href="https://discord.gg/ctDAYrrNTH">
          <strong>Discord</strong>
        </a>{' '}
        for latest updates.
      </p>
      {/* <p>Your past trade history is recorded. ZKEX will clear past data for the next event.</p> */}
    </Modal>
  )
})
